import React, { useState, useEffect } from 'react';
import { StyledPaper, StyledTable, StyledTableRow, StyledTableCell } from '../../../uiComponents/MuiTable/StyledTable.js'
import MuiTableHeader from '../../../uiComponents/MuiTable/MuiTableHeader';
import LiteratureLink from '../../../uiComponents/LiteratureLink.js';
import LiteratureUtils from '../../../utils/LiteratureUtils.js';
import {stableSort,getComparator} from '../../../uiComponents/MuiTable/MuiHelper';
import APIUtils from '../../../utils/APIUtils.js';
import LoadingInner from '../../Loading/LoadingInner';
import {
  TableBody,
  TableContainer,
} from '@mui/material';


export default function ReadOnlyLiteratureTable(props) {
  const [tableData, setTableData] = useState([]);
 const [categories, setCategories] = useState([]);
   const [order, setOrder] = useState('asc');
   const [orderBy, setOrderBy] = useState('pmid');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
 useEffect(() => {
    fetchLiteratureReviews();
  }, [props.variantInterpretationId]);

    useEffect(() => {
      fetchCategories()
    }, []);
  
   async function fetchLiteratureReviews() {
        setLoading(true);
        try {
          var response = await APIUtils.getLiteratureReviewsForReview(props.variantInterpretationId);
          setTableData(response);
        } finally {
          setLoading(false);
        }
    }
  async function fetchCategories() {
        const response = await APIUtils.getLiteratureCategories();
        setCategories(response);
    }
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
    const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };  
  //Important: The id here must match the column name in the returned data. Label can be different for display.
  const headCells = [
    { label: 'PMID', id: 'pmid', numeric: false, disablePadding: false },
    { label: 'ACMG Criteria', id: 'acmgEvidCriteriaId', type: 'noSort', numeric: false, disablePadding: false },
    { label: 'Category', id: 'litCategory', type: 'noSort', numeric: false, disablePadding: false },
    { label: 'Comments', id: 'litComment', type: 'noSort', numeric: false, disablePadding: false }
    ];

  return (
    <>

        {loading ? (
          <LoadingInner isLoadingInner={loading} />
        ) : tableData.length > 0 ? (
          <StyledPaper>
            <TableContainer>
              <StyledTable
                size='small'
                aria-label="literature table">
                <MuiTableHeader
                  headCells={headCells}
                  order={order}  
                  orderBy={orderBy} 
                  onRequestSort={handleRequestSort}
                />
                <TableBody> 
                  {stableSort(tableData, getComparator(order, orderBy))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                     .map((row, index) => {
                        // Format litEval to add a space after each comma
                          return (
                        <StyledTableRow tabIndex={-1} key={index}>
                          <StyledTableCell style={{ minWidth: '120px' }}><LiteratureLink pmid={row.pmid} /></StyledTableCell>
                          <StyledTableCell style={{width: '15%'}}>{LiteratureUtils.formattedLitEval(row)}</StyledTableCell>
                          <StyledTableCell style={{width: '25%'}}>{LiteratureUtils.renderCategoryLabel(categories, row)}</StyledTableCell>
                          <StyledTableCell>{row.comment}</StyledTableCell>
                        </StyledTableRow>
                        );
                    })}
                </TableBody>
              </StyledTable>
            </TableContainer>
          </StyledPaper>
        ) : (
          <div className="noData">
            No literature to display
          </div>
        )
        }
 
    </>
  );
}
